<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-01-13 18:18:34 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-09 11:29:03 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/action-sheet/src/izt-action-sheet.vue
 * @Description  : action-sheet组件
 * action-sheet 容器最大70vh
-->
<style lang="scss" scoped>
.izt-action-sheet-container {
  background-color: var(--izt-background-color);
  padding: 0;
  line-height: 1;
  font-size: 28px;
  position: relative;
  .header-container {
    padding: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      flex: 1;
      font-weight: bold;
      font-size: 28px;
      color: var(--izt-background-text-color-65);
      line-height: 42px;
      text-align: left;
      font-style: normal;
    }
    .close {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .sheet-main-container {
    padding: 0 24px;
  }
  .sheet-footer {
    padding: 24px 30px;
    padding-bottom: 55px;
  }
  .sheet-footer.suspension {
    position: absolute;
    bottom: 55px;
    right: 24px;
    padding: 0;
  }
}
</style>

<template>
  <van-action-sheet :show="show" :overlay="overlay" @click-overlay="close">
    <div class="izt-action-sheet-container" :class="className">
      <div class="header-container">
        <div class="title">{{title}}</div>
        <div class="close" @click="close">
          <izt-icon class-name="icon-guanbi" />
        </div>
      </div>
      <div class="sheet-main-container">
        <slot />
      </div>
      <div :class="['sheet-footer', suspension && 'suspension']" v-if="isFooter">
        <slot name="footer" />
      </div>
    </div>
  </van-action-sheet>
</template>

<script setup name="izt-action-sheet">
  import { useSlots } from 'vue'
  defineOptions({ name: 'izt-action-sheet' })
  defineProps({
    className: {
      type: [String, Array],
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: Boolean,
      default: true
    },
    suspension: {
      type: Boolean,
      default: false
    },
  })
  const emit = defineEmits(['update:show', 'close'])

  const isFooter = !!useSlots()['footer']

  const close = () => {
    emit('update:show', false)
    emit('close')
  }
</script>